import React, { Suspense, lazy } from "react";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Sidebar from "./components/layout/Sidebar";
import { SyncProvider, useSync } from "./data/SyncContext";
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./auth/ProtectedRoute";
import { RefreshCw, Loader2, Database } from "lucide-react";

const Home = lazy(() => import("./pages/Home"));
const Ventas = lazy(() => import("./pages/Ventas"));
const Analisis = lazy(() => import("./pages/Analisis"));
const Inventario = lazy(() => import("./pages/Inventario"));
const Compras = lazy(() => import("./pages/Compras"));
const Proveedores = lazy(() => import("./pages/Proveedores"));
const Productos = lazy(() => import("./pages/Productos"));
const LoginPage = lazy(() => import("./pages/LoginPage"));

function PageLoader() {
  return (
    <div className="loader">
      <Loader2 size={24} />
    </div>
  );
}

function SyncBanner() {
  const { syncStatus, triggerSync } = useSync();

  if (syncStatus.is_syncing) {
    return (
      <div className="card" style={{ marginBottom: 24, display: "flex", alignItems: "center", gap: 12, padding: "12px 16px" }}>
        <Loader2 size={16} className="animate-spin" style={{ color: "var(--accent)" }} />
        <span style={{ fontSize: 13, color: "var(--text-secondary)" }}>{syncStatus.progress || "Sincronizando datos..."}</span>
      </div>
    );
  }

  if (!syncStatus.has_data) {
    return (
      <div className="card" style={{ marginBottom: 24, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", background: "var(--orange-light)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Database size={16} style={{ color: "var(--orange)" }} />
          <span style={{ fontSize: 13, color: "var(--text-secondary)" }}>Sin datos. Sincroniza para comenzar.</span>
        </div>
        <button className="btn btn-primary" onClick={triggerSync} style={{ padding: "8px 14px" }}>
          <RefreshCw size={14} /> Sincronizar
        </button>
      </div>
    );
  }

  return null;
}

function AppShell() {
  const { syncStatus, triggerSync } = useSync();

  return (
    <div className="app-layout">
      <Sidebar onSync={triggerSync} syncing={syncStatus.is_syncing} />
      <main className="main-content">
        <div className="page-container">
          <SyncBanner />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ventas" element={<Ventas />} />
              <Route path="/analisis" element={<Analisis />} />
              <Route path="/inventario" element={<Inventario />} />
              <Route path="/compras" element={<Compras />} />
              <Route path="/proveedores" element={<Proveedores />} />
              <Route path="/productos" element={<Productos />} />
            </Routes>
          </Suspense>
        </div>
      </main>
    </div>
  );
}

function ProtectedShell() {
  return (
    <SyncProvider>
      <AppShell />
    </SyncProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <ProtectedShell />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
